<script>
  import { user } from '../stores'
  import OpenBuyModalButton from '../components/OpenBuyModalButton.svelte'
  import Insert from '../elements/Insert.svelte'
  import Pill from '../elements/Pill.svelte'
  import EmptyStateFooterList from './EmptyStateFooterList.svelte'
</script>

{#if $user === undefined}
  <div class="sample_tags">
    <Pill>Script</Pill><Pill>Cursive</Pill><Pill>Handwritten</Pill><Pill>Favorites</Pill><Pill>Christmas</Pill><Pill>Sports</Pill><Pill>Decorative</Pill><Pill>Retro</Pill><Pill>Fun</Pill>
    <small>(Sample tags *)</small>
  </div>
{/if}
<div class="content">
  {#if $user === undefined}
    <div class="pointer">👆</div>
    <Insert persistent insert_position="before_previews">
      <span slot="toptitle">
        PRO FEATURE: TAGGING
      </span>
      <span slot="title">
        Organize your fonts into categories,<br>
        instantly narrow down your options!
      </span>
      <span slot="text">
        Do you spend way too much time scrolling through all your fonts?<br>
        Tag and categorise your fonts and save tons of time while searching.<br>
        <small>
          Tagging is available in Wordmark Pro along with many other time saving features.
        </small>
      </span>
      <span slot="button">
        <OpenBuyModalButton feature='taged_fonts_page'>Subscribe to <b>Wordmark Pro</b></OpenBuyModalButton>
      </span>
    </Insert>
    <EmptyStateFooterList classList="ml-1">
      <small>* &nbsp;Tags shown here are for demonstration purposes, Wordmark cannot automatically categorize your fonts.</small>
      <li><small><a href="/help/tagging/" target="_blank">Learn more about tagging</a> in our help pages.</small></li>
    </EmptyStateFooterList>
  {:else}
    <div class="body">
      <h2>
        Tag and categorise your fonts,<br>
        <span>save time finding them later</span>
      </h2>
      <p>
        This feature is useful if you don&rsquo;t want to scroll through all your fonts every time.<br>
        By tagging and categorising your fonts by style, project, or purpose, you can instantly narrow down your options.<br>
      </p>
      <p>
        <b>To get started</b> <span class="arrow">⇢</span> <span class="action">Select</span> the fonts you want to tag <span class="arrow">⇢</span> <span class="action">Filter</span> selected fonts <span class="arrow">⇢</span> click the <span class="action">Tag</span> button on top left.<br>
        Many people start by tagging their fonts: Script, Handwriting, Favourites, Retro, etc.
      </p>
    </div>
      <EmptyStateFooterList>
        <li><small>Fonts can have multiple tags.</small></li>
        <li><small>Tags work across all installed, dropped, and uploaded fonts.</small></li>
        <li><small>You can also tag fonts by clicking the plus button on their bottom right.</small></li>
        <li><small><a href="/help/tagging/" target="_blank">Learn more about tagging</a> in our help pages.</small></li>
      </EmptyStateFooterList>
  {/if}
</div>

<style>
  .sample_tags {
    width: calc(100% + 2rem);
    margin: -2rem -1rem;
    padding-left: 2rem;
    padding-bottom: 1rem;
    background-color: var(--c-nav-bg);
  }

  .pointer {
    padding-left: 3rem;
    font-size: 5rem;
    line-height: 4rem;
  }

  .content {
    min-height: calc(100vh - 16rem);
  }
  .body {
    padding: 2rem 1rem 3rem;
  }
  .body h2 {
    font-size: 2.2rem;
    margin-bottom: 2.5rem;
  }
  .body h2 span {
    color: var(--c-text);
  }
  .body p {
    margin-top: 3rem;
  }
  
  .arrow {
    font-size: 1.25em;
    vertical-align: bottom;
    margin: 0 0.25rem;
  }
  .action {
    color: var(--c-accent);
    font-family: var(--PensumSans-Bold);
  }
</style>